var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.185,
    height: 19.616,
    viewBox: "0 0 21.185 19.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M506.708,649.284H485.918v-2.593l4.658-5.928,1.367,1.074-4.286,5.455v.253h19.051Z",
    transform: "translate(-485.523 -640.764)",
    fill: "#1a1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M501.276,664.929l-1.367-1.074L504.2,658.4v-.253H485.144v-1.738h20.789V659Z",
    transform: "translate(-485.144 -645.313)",
    fill: "#1a1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.b495cadf45922867be11ff4ed48a5931.svg";
export { ForwardRef as ReactComponent };